import styled from "styled-components";
import { Link } from "gatsby";
import linkedinSvg from "@assets/images/icons/linkedin.svg";
import youtubeSvg from "@assets/images/icons/youtube.svg";
import instagramSvg from "@assets/images/icons/instagram.svg";
import greatPlaceToWorkImg from "@assets/images/icons/great-place-to-work.png";
import isoCertifiedSvg from "@assets/images/icons/iso-certified.svg";

const socialIcons = {
  instagram: instagramSvg,
  youtube: youtubeSvg,
  linkedin: linkedinSvg,
};

export const Footer = styled.footer`
  display: flex;
  flex-direction: column;
`;

export const Subscribe = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 32px 16px;
  background-color: #262626;
  column-gap: 36px;
  height: 372px;
  color: #fff6ed;

  /* Hubspot newsleter form styles */

  & #hubspot-form form {
    margin-bottom: 0px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    height: auto;
    row-gap: 24px;

    & #hubspot-form {
      width: 100%;
    }
  }

  & .actions {
    margin-top: 16px;
  }

  & .hs-input {
    width: 372px;
    min-width: 240px;
    border-radius: 8px;
    border: none;
    padding: 12px 16px;

    @media (max-width: 600px) {
      width: 100%;
    }
  }

  & .hs-button {
    background-color: ${({ disabled }) => (disabled ? "#BABABA" : "#F40")};
    width: fit-content;
    display: block;
    cursor: pointer;
    min-width: 198px;
    text-align: center;
    user-select: none;
    color: #fff;
    text-decoration: none;
    font-size: 25px;
    padding: 6px 16px;
    font-weight: 400;
    border-width: 0px;
    border-style: none;
    border-color: none;
    border-image: initial;
    margin: auto;

    &:hover {
      background-color: ${({ disabled }) => !disabled && "#CC3600"};
    }

    &:active {
      background-color: ${({ disabled }) => !disabled && "#8B2500"};
    }
  }
`;

export const Summary = styled.div`
  display: flex;
  flex: 1;
  position: relative;
  justify-content: end;

  @media (max-width: 600px) {
    row-gap: 16px;
    justify-content: start;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  flex: 0;
  position: relative;
`;

export const Title = styled.p`
  font-size: 52px;
  font-weight: 500;
  line-height: 64px;
  margin: 0;
  color: #fff;
  width: max-content;

  @media (max-width: 600px) {
    font-size: 39px;
    line-height: 51px;
  }
`;

export const Subtitle = styled.p`
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  line-height: 28px;
  width: 60%;
  text-align: left;
  color: #fff;
  width: 100%;

  @media (max-width: 600px) {
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    width: 100%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  margin: 0;
  align-items: center;
  flex: 1;
  padding: 24px 0;
  justify-self: center;

  @media (max-width: 600px) {
    padding: 24px 0;
    align-items: start;
    width: 100%;
  }
`;

export const Input = styled.input`
  width: 372px;
  min-width: 240px;
  border-radius: 8px;
  border: none;
  padding: 12px 16px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

export const Container = styled.div`
  padding: 40px;
  background-color: #f9f9f9;
  display: flex;
  justify-content: space-between;
  height: 450px;

  @media (max-width: 600px) {
    flex-direction: column;
    padding: 40px 24px;
    row-gap: 40px;
    height: auto;
  }
`;

export const Info = styled.div`
  display: flex;
  column-gap: 24px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    row-gap: 40px;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const InfoTitle = styled.p`
  margin: 0;
  color: #575757;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const InfoText = styled.p`
  color: #575757;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`;

export const InfoLink = styled(Link)`
  color: #575757;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
`;

export const ExternalLink = styled.a`
  color: #575757;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
`;

export const Socials = styled.div`
  display: flex;
  column-gap: 10px;
`;

export const SocialsLink = styled.a`
  width: 30px;
  height: 30px;
  display: inline-block;
  border-radius: 50%;
  background-color: #5f6d67;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 25%;
    left: 25%;
    width: 50%;
    height: 50%;
    -webkit-mask: url(${({ type }) => socialIcons[type] || linkedinSvg})
      no-repeat center;
    -webkit-mask-size: contain;
    mask: url(${({ type }) => socialIcons[type] || linkedinSvg}) no-repeat
      center;
    mask-size: contain;
    background-color: #fff;
  }
`;

export const SimpleColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const OfficesContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;

  @media (max-width: 600px) {
    align-items: start;
    justify-content: unset;
  }
`;

export const Offices = styled.div`
  display: flex;
  column-gap: 16px;

  & p:not(:last-child) {
    padding-right: 16px;
    border-right: solid 1px #575757;
  }

  @media (max-width: 600px) {
    justify-content: space-between;
    width: 100%;

    & p:not(:last-child) {
      padding: 0;
      border: unset;
    }
  }
`;

export const Office = styled.p`
  margin: 0;
  color: #575757;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 9px;
`;

export const Copyright = styled.p`
  color: #575757;
  text-align: right;
  font-size: 12px;
  font-weight: 400;
  text-transform: uppercase;
  margin-bottom: 40%;

  @media (max-width: 600px) {
    margin: 0;
  }
`;

export const IsoIconsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const GreatPlaceToWorkIcon = styled.img`
  content: url(${greatPlaceToWorkImg});
  margin: 0;

  @media (max-width: 600px) {
    max-width: 70px;
  }
`;

export const IsoCertifiedIcon = styled.img`
  content: url(${isoCertifiedSvg});
  margin: 0;

  @media (max-width: 600px) {
    max-width: 140px;
  }
`;

export const Responsive = styled(OfficesContainer)`
  @media (max-width: 600px) {
    flex-direction: row;
    column-gap: 5px;
    align-items: center;
  }
`;
